import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import './registerServiceWorker'

Vue.config.productionTip = false

import Snotify, { SnotifyPosition } from 'vue-snotify'
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop,
    showProgressBar: false,
    timeout: 3000,
    titleMaxLength: 50,
    bodyMaxLength: 200
  },
  global: {
    preventDuplicates: true
  }
})

// Tlumaczenia
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const messages = {}
messages['pl'] = require('./translations/pl/pl')
const i18n = new VueI18n({ locale: 'pl', messages })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created () {
    this.$store.dispatch('app/INIT')
  }
}).$mount('#app')
